import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;

// Fonction pour convertir une image en base64
const convertImageToBase64 = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

const ModifierAnnonceService = async (idAnnonce: string, data: any, imageFile: File | null) => {
  try {
    const userId = localStorage.getItem('userId');
    const departementNumber = Number(data.departement);
    const jalNumber = Number(data.jal);
    
    let enteteBase64: string | null = data.entete || '';
    if (imageFile) {
      enteteBase64 = await convertImageToBase64(imageFile);
    }

    const body = {
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      numdossier: data.numdossier,
      numannonce: data.numannonce,
      referenceClient: localStorage.getItem('reference'),
      annonceur: data.annonceur,
      annonce: data.annonce,
      departement: departementNumber,
      jal: jalNumber,
      justif: data.justif,
      demande: data.demande,
      type: data.type,
      stype: data.stype,
      entete: enteteBase64,
      floid: data.floid,
      userId: userId,
      textAnnonce: data.textAnnonce,
      denomination: data.denomination,
    };

    // Envoie de la requête PUT pour modifier l'annonce
    const response = await axios.put(`${API_URL}/annonce/annonces/${idAnnonce}`, body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Ajoutez l'en-tête d'autorisation si nécessaire
      }
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Erreur lors de la modification de l'annonce :", error.response?.data || error.message);
    } else {
      console.error("Erreur inconnue lors de la modification de l'annonce :", error);
    }
    throw error;
  }
};

export default ModifierAnnonceService;
